export enum SectorTypes {
    SEATED = 'seated',
    STANDING = 'standing',
}